// extracted by mini-css-extract-plugin
export default {"container":"jH-z","disabled":"kH-z","bgBlack":"lH-z","content":"mH-z","countdown":"nH-z","topCaption":"oH-z","topHeading":"pH-z","heading":"qH-z","copy":"rH-z"};